export const listGender = ['男性', '女性', 'その他'];
